import { CanCommands } from '@tiptap/core';
import { ChainedCommands, ExtendedRegExpMatchArray, Extension, InputRule, Range, SingleCommands } from '@tiptap/core'
import { EditorState } from '@tiptap/pm/state';

const handlerByMarkType: ( props: {
  state: EditorState;
  range: Range;
  match: ExtendedRegExpMatchArray;
  commands: SingleCommands;
  chain: () => ChainedCommands;
  can: () => CanCommands;
}, markType: string ) => void | null = ( props, markType ) => {
  const { tr, schema } = props.state;

  const _markType = schema.marks[ markType ];

  if ( !_markType ) return null;

  tr.delete( props.range.from, props.range.to );

  tr.insertText( props.match[ 1 ], props.range.from );

  tr.addMark( props.range.from, props.range.from + props.match[ 1 ].length, _markType.create());
};

export const ChannelInputRules = Extension.create({
  name: 'channelInputRules',

  addInputRules() {
    return [
      // Bold: *texto*
      new InputRule({
        find: /\*(.+)\*$/,
        handler: ( props ) => handlerByMarkType( props, "bold"),
      }),

      // Italic: _texto_
      new InputRule({
        find: /_(.+)_$/,
        handler: ( props ) => handlerByMarkType( props, "italic"),
      }),

      // Strike: ~texto~
      new InputRule({
        find: /~(.+)~$/,
        handler: ( props ) => handlerByMarkType( props, "strike"),
      }),

      // Inline code: `texto`
      new InputRule({
        // [\s\S] permite múltiplas linhas, ? evita guloso
        find: /`([\s\S]+?)`$/,
        handler: (props) => handlerByMarkType( props, "code"),
      }),
    ]
  },
})
